import { match as confirmMatcher } from "../../../src/params/confirmMatcher.ts";
import { match as endsOnInt } from "../../../src/params/endsOnInt.ts";
import { match as groupTypeMatcher } from "../../../src/params/groupTypeMatcher.ts";
import { match as hubPrefixMatcher } from "../../../src/params/hubPrefixMatcher.ts";
import { match as manageContentTypeMatcher } from "../../../src/params/manageContentTypeMatcher.ts";
import { match as newslettersOverviewMatcher } from "../../../src/params/newslettersOverviewMatcher.ts";
import { match as signupMatcher } from "../../../src/params/signupMatcher.ts";

export const matchers = { confirmMatcher, endsOnInt, groupTypeMatcher, hubPrefixMatcher, manageContentTypeMatcher, newslettersOverviewMatcher, signupMatcher };